module.exports = __webpack_public_path__ + "static/img/price-bg-blue.ad0e49a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/price-bg-blue.png
// module id = RZDV
// module chunks = 0